/**
 * 功能: 报告里的更新日志的录入
 */
<template lang="pug">
div#report-log
    report-nav(:mainId="mainId" :title="title" :kind="kind" :status="status")
    el-form(
      label-width="90px"
      :model="log"
      :rules="briefLogRules"
      ref="briefLogRef"
      :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="6")
          el-form-item(label="作者" prop="author")
            el-input(v-model="log.author")
        el-col(:span="7")
          el-form-item(label="发布日期" prop="pubDate")
            el-date-picker(
              v-model="log.pubDate"
              type="date"
              placeholder="选择日期")
        el-col(:span="8")
          el-form-item(label="是否公开")
            el-checkbox(v-model="log.publicity")
      el-row
        el-col(:span="14")
          el-form-item(label="公开描述")
            el-input(type="textarea" :rows="9" v-model="log.description")
        el-col(:span="6" :push="1")
          el-upload.upload-demo(
            drag
            :action="GLOBAL.uploadHost + 'brief/uploadLog'"
            :headers="headers"
            :on-success="handleUploadLog"
            :before-upload="handleBeforeUpload"
            :on-error="handleUploadErr")
            i.el-icon-upload
            div.el-upload__text 将文件拖到此处，或
              em 点击上传
            //- div.el-upload__tip(slot="tip") 不超过500kb
    el-row
      el-col(:span="21")
        el-button.fr(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="iCanUpload || isSave" @click="handleCreateLog") 添加
    el-row
      el-table(
        :data="logList"
        style="width: 100%")
        el-table-column(
          prop="author"
          label="作者"
          width="100"
          align="center")
        el-table-column(
          prop="pubDate"
          label="发布日期"
          width="100"
          align="center")
          template(slot-scope="scope")
            p {{ scope.row.pubDate | formatTime }}
        el-table-column(
          prop="publicity"
          label="是否公开"
          align="center"
          width="80")
          template(slot-scope="scope")
            p {{ scope.row.publicity | whether }}
        el-table-column(
          prop="originalFile"
          label="附件"
          width="270")
        el-table-column(
          prop="description"
          label="公开描述")
        el-table-column(label="操作" width="300" fixed="right" align="center")
          template( slot-scope="scope")
            el-button-group
              el-button(title="修改" :size="GLOBAL.SIZE_OF_INPUTBOX" round icon="el-icon-edit" type="primary" @click="handleUpdate(scope.row)")
              el-button(v-if="scope.row.originalFile" title="下载" :size="GLOBAL.SIZE_OF_INPUTBOX" round icon="el-icon-download" type="warning" @click="downLoadFile(scope.row)")
              el-button(title="删除" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="isSave" round icon="el-icon-delete" type="danger" @click="handleDelLog(scope.row._id)")
    log-dialog(ref="logRef" @update="handleUpdateLog")
</template>

<script>
import ReportNav from './components/reportNav'
import api from '@/apis/brief'
import passport from '@/javascripts/passport'
import LogDialog from './components/logDialog'
export default {
  name: 'ReportLog',
  components: { ReportNav, LogDialog },
  data () {
    return {
      briefLogRules: {
        author: { required: true, message: '请输入作者名称', trigger: 'blur' },
        pubDate: { required: true, message: '请选择发布日期', trigger: 'blur' }
      },
      headers: passport.headers(),
      mainId: -1,
      kind: 0,
      title: '',
      log: {
        publicity: false
      },
      iCanUpload: false,
      logList: [],
      isSave: false
    }
  },
  created () {
    this.mainId = this.$route.query.id
    this.log.brief = this.$route.query.id
    this.kind = localStorage.kind
    this.title = localStorage.title
    this.status = Number(localStorage.status)
    if (this.status && this.status >= 1) {
      this.isSave = true
    }
    this.getBriefLoglist()
  },
  methods: {
    // 创建报告的更新日志
    handleCreateLog () {
      this.$refs.briefLogRef.validate(valid => {
        if (valid) {
          api.createBriefLog(this.log).then(res => {
            if (res.errCode === 0) {
              this.$message({ type: 'success', message: '添加日志成功!' })
              this.log = { publicity: false, brief: this.mainId }
              this.getBriefLoglist()
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: '添加日志失败!' + err
            })
          })
        }
      })
    },
    // 获取报告日志的列表
    getBriefLoglist () {
      api.getBriefLogList({ id: this.$route.query.id }).then(res => {
        this.logList = res.data
        // this.logList = this.logList.splice(0, this.logList.length)
      })
    },
    // 上传更新的附件
    handleUploadLog (response, file, fileList) {
      if (response.errCode !== 0) return this.$message({ type: 'error', message: response.msg })
      this.$message({ type: 'success', message: '上传附件成功！' })
      this.iCanUpload = false
      this.log.originalFile = response.data
    },
    // 文件上传之前的处理
    handleBeforeUpload () {
      this.iCanUpload = true
    },
    // 上传文件的错误处理
    handleUploadErr () {
      this.iCanUpload = false
      this.$message({ type: 'error', message: '上传附件失败！上传超时' })
    },
    // 删除更新日志
    handleDelLog (id) {
      api.delBriefLog({ id }).then(res => {
        if (res.errCode === 0) {
          this.$message({ message: '删除成功！', type: 'success' })
          this.getBriefLoglist()
        }
      }).catch(err => {
        this.$message({ message: '删除失败！' + err, type: 'success' })
      })
    },
    // 打开更新日志的弹框
    handleUpdate (obj) {
      this.$refs.logRef.show(obj)
    },
    // 更新日志
    handleUpdateLog (data) {
      api.updateBriefLog(data).then(res => {
        if (res.errCode === 0) {
          this.$message({ type: 'success', message: '更新日志成功！' })
          this.$refs.logRef.isShow = false
          this.getBriefLoglist()
        }
      }).catch(err => {
        this.$message({ type: 'success', message: '更新日志失败！' + err })
      })
    },
    // 下载附件
    downLoadFile (row) {
      const loading = this.$loading({
        lock: true,
        text: '下载中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.downloadLogFile({ url: row.originalFile }).then(res => {
        if (res.errCode !== 0) return this.$message.error(res.msg)
        if (!res.data) return this.$message.error('未找到文件')
        const url = res.data
        // const buf = Buffer.from(res.data.content, 'binary')
        // let blob = new Blob([buf])
        // let url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = row.originalFile
        a.href = url
        a.click()
      }).catch(err => {
        this.$message({ type: 'error', message: '下载文件失败!' + err })
      }).finally(() => {
        loading.close()
      })
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        val = new Date(val).toLocaleDateString()
        return val.toString().slice(0, 10)
      } else {
        return null
      }
    }
  }
}
</script>

<style>

</style>
